import React from 'react'
import Header from '../compontents/Header'
import BookTable from '../compontents/BookTable'
import Footer from '../compontents/Footer'

const BookTablePage = () => {
  return (
    <React.Fragment>
      <Header />
      <BookTable />
      <Footer />
    </React.Fragment>
  )
}

export default BookTablePage